export function UnitsFilter() {
  return function (object, value) {
    return object ? `${object} ${value}` : `н/д`
  }
}
